import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TsunamiIcon(props: IconProps) {
    return <Icon {...props} iconKey={"tsunami"}/>
}
